import { invoke } from 'apps/vtex/runtime.ts'
import { Product } from 'apps/commerce/types.ts'
import { useEffect, useState } from 'preact/hooks'
import Image from 'apps/website/components/Image.tsx'
export interface Props {
    productID: string
}

export default function BuyTogetherAnalysis({ productID }: Props) {
    if (globalThis.location.pathname !== '/product-view-analysis') return null
    const [products, setProducts] = useState<Product[]>([])
    useEffect(() => {
        ;(async () => {
            const relatedProducts = await invoke.vtex.loaders.legacy.relatedProductsLoader({
                crossSelling: 'showtogether',
                count: 5,
                id: productID,
                hideUnavailableItems: false,
            })

            if (!relatedProducts || !relatedProducts.length) return
            setProducts(relatedProducts)
        })()
    }, [productID])

    if (!products.length) return null

    return (
        <div class='w-full gap-2'>
            {products?.map((product) => {
                const { image, alternateName } = product

                const slicedName = alternateName?.slice(0, 63)

                return (
                    <div class='bg-[#EBEBEB99] p-2 flex gap-5'>
                        <Image
                            src={image?.[0].url ?? ''}
                            alt={image?.[0].alternateName ?? ''}
                            width={40}
                            height={40}
                        />

                        <div class='flex flex-col'>
                            <span class='text-primary-700 text-xs font-bold'>Compre Junto:</span>
                            <span class='text-xs font-bold text-black'>{slicedName}</span>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
